import { useState, useEffect } from "react";
import { PlusOutlined, HolderOutlined, DeleteOutlined } from "@ant-design/icons"
import { Button, Flex, Switch, Input, message } from "antd"
import { v4 as uuidv4 } from "uuid";
import DropdownInput from "../Object/DropdownInput";
import { useTranslation } from 'react-i18next';

const Tools = (props) => {
    const { t } = useTranslation();
    const { sprintDetail, masterList, estimationData, updateEstimation } = props
    const [tools, setTools] = useState([])
    const [toolMasterData, setToolMasterData] = useState([])
    const [formFields, setFormFields] = useState([])
    const [costViewEnable, setCostViewEnable] = useState(false)

    useEffect(() => {
        if (estimationData.tools) {
            setTools(estimationData.tools)
        }
    }, [estimationData.tools])

    const getToolData = () => {
        let reqObjectData = masterList.find(data => data.dataName === "Tool")
        setToolMasterData(reqObjectData?.data || [])
        setFormFields(reqObjectData?.fields || [])
    }

    useEffect(() => {
        if (masterList.length > 0) {
            getToolData();
        }
    }, [masterList])


    const handleToolChange = (tool, key, value) => {
        let currentTool = tools.find(tool => tool["Tool"] === value)
        if(currentTool){
            message.error(t('Selected tool is already added'))
            return
        }
        let updatedTools = tools.map(toolData => {
            let toolObj = {...toolData}
            if (toolData.uuid === tool.uuid) {
                toolObj[key] = value
            }
            if(toolObj.new){
                delete toolObj.new
            }
            return {...toolObj}
        })
        updateEstimation("tools", updatedTools)
    }

    const addTool = () => {
        let durationData = {}
        for (let i = 1; i <= sprintDetail.duration; i++) {
            durationData[i] = ""
        }
        let updatedTools = [...tools, { uuid: uuidv4(), "Tool": "", new: true, count: { ...durationData } }]
        updateEstimation("tools", updatedTools)

    }

    const handleEffortChange = (objId, effort, value) => {
        let updatedTools = [...tools];
        updatedTools = updatedTools.map(obj => {
            if (obj.uuid === objId) {
                return { ...obj, count: { ...obj.count, [effort]: Number(value)} }
            } else {
                return { ...obj }
            }
        })
        updateEstimation("tools", updatedTools)

    }

    const deleteTool = (toolId) => {
        let updatedTools = tools.filter(tool => tool.uuid !== toolId);
        updateEstimation("tools", updatedTools)
    }

    const handleEnableCost = (checked) => {
        setCostViewEnable(checked);
        let updatedTools = [...estimationData.tools];
        if(checked){
            updatedTools = updatedTools.map(tool => {
                return {...tool, count: tool.calculatedEfforts}
            })
        } else {
            updatedTools = updatedTools.map(tool => {
                return {...tool, count: tool.count}
            })
        }
        setTools(updatedTools)
    }


    return (
        <>
            <Flex justify="space-between" align="center" style={{ padding: "0.75rem 2.5rem" }}>
                <div className="text-" style={{ color: "#000" }}>{t('Tools')}</div>
            </Flex>
            <div className="sprint-container tool-container" style={{ minHeight: tools.length === 0 ? "23rem" : "fit-content" }}>
                <div className="sprint-header-row">
                    <div className="sprint-left-section">
                        <div className="add-sprint" style={{ justifyContent: "space-between", padding: "0 1rem 0 2.5rem" }}>
                            <span><Button className="submit-button" size="small" icon={<PlusOutlined />} style={{ marginRight: "8px" }} onClick={addTool} />{t('Add Tool')}</span>
                            <span>{t('Cost View')} <Switch size="small" checked={costViewEnable} onChange={handleEnableCost} /></span>
                        </div>

                    </div>

                    <div className="sprint-right-section">
                        <div className="empty-block">{sprintDetail.timeline} </div>
                        <Flex>
                            {
                                [...Array(sprintDetail.duration)].map((e, i) => {
                                    return <div className="week-block" key={i} >
                                        <div className="week-cell" style={{ borderLeft: i === 0 ? "0px solid" : "1px solid #C7C8F3" }}>
                                            {Number(i + 1)}
                                        </div>
                                    </div>
                                })
                            }

                            <div className="week-block" style={{ flexGrow: "1", maxWidth: "none" }}>
                                <div className="week-cell" style={{ justifyContent: "flex-start", paddingLeft: "1rem", borderLeft: "1px solid #C7C8F3" }}>
                                </div>
                            </div>
                        </Flex>

                    </div>
                </div>
                {
                    tools.length > 0 && tools.map((tool, index) => {
                        return (
                            <div className="sprint-row">
                                <Flex className="left-section-row-data tool-object-row" vertical>
                                    <div className="add-sprint-item" style={{ gap: 0 }}>
                                        <Flex gap={5} className="sprint-action">
                                            <HolderOutlined style={{ marginRight: "5px", visibility: "hidden" }} />
                                            <PlusOutlined style={{ visibility: "hidden" }} />
                                        </Flex>
                                        <div className={`object-input ${tool.new ? "" : "tool-input"}`}>
                                            <DropdownInput masterData={toolMasterData} data={tool} fieldLabel="Tool" parentValue="" handleChange={handleToolChange} width="100%" />
                                        </div>
                                        <DeleteOutlined className="app-icon delete-icon" onClick={() => deleteTool(tool.uuid)} />
                                    </div>
                                </Flex>
                                <div className="add-sprint-item" style={{ display: "flex", width: "100%" }}>
                                    {
                                        [...Array(sprintDetail.duration)].map((e, i) => {
                                            let currentDuration = Number(i + 1)
                                            return <div className="week-block object-effort-block object-input" style={{ display: "flex", alignItems: "center" }}>
                                                {
                                                    costViewEnable ? <div style={{width: "100%", textAlign: "center"}}>{tool.count?.[currentDuration]}</div>
                                                    : <Input value={tool.count[currentDuration]} onChange={(e) => handleEffortChange(tool.uuid, String(currentDuration), e.target.value)} style={{ textAlign: "center" }} />
                                                }

                                            </div>
                                        })
                                    }
                                </div>

                            </div>
                        )
                    })
                }
            </div>
        </>
    )
}

export default Tools